import type { MemberAccessRule } from './types.js';

export const PYTHON_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'attribute', objectField: 'object', propertyField: 'attribute', tagKind: 'member' },
];
